import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function CounterItem({ end, label, suffix = '' }) {
    const countRef = useRef(null);
    const elRef = useRef(null);

    useEffect(() => {
        const el = elRef.current;
        const counter = { value: 0 };

        gsap.to(counter, {
            value: end,
            duration: 2,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: el,
                start: 'top 85%',
                once: true,
            },
            onUpdate: () => {
                if (el) {
                    el.textContent = Math.round(counter.value).toLocaleString('fr-BE') + suffix;
                }
            },
        });
    }, [end, suffix]);

    return (
        <div className="text-center">
            <div
                ref={elRef}
                className="text-4xl md:text-5xl font-bold text-accent-500 mb-2 font-serif"
            >
                0
            </div>
            <div className="text-primary-100 font-medium">{label}</div>
        </div>
    );
}

export default function StatsCounter() {
    return (
        <section className="py-20 bg-primary-900 text-white relative overflow-hidden">
            {/* Decorative background elements */}
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
                <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary-500 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
            </div>

            <div className="container mx-auto px-6 relative z-10">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div className="text-center">
                        <div className="text-4xl md:text-5xl font-bold text-accent-500 mb-2 font-serif">
                            1978
                        </div>
                        <div className="text-primary-100 font-medium">Depuis</div>
                    </div>
                    <CounterItem end={350} label="Sympathisants" suffix="+" />
                    <CounterItem end={16} label="Conférences / an" />
                    <CounterItem end={1} label="Excursion / an" />
                </div>
            </div>
        </section >
    );
}
